<template>
<div class="chapter">
<div class="inner_page">
<h1 class="CH-T"><strong>Contents</strong></h1>
<h2 class="TOC-CH-T"><a href="#/OEBPS/c01.htm"><strong>Pompom Cushion</strong></a></h2>
<h2 class="TOC-CH-T"><a href="#/OEBPS/c02.htm"><strong>Bright Stripe Pillows</strong></a></h2>
<h2 class="TOC-CH-T"><a href="#/OEBPS/c03.htm"><strong>Beaded Cushion</strong></a></h2>
<h2 class="TOC-CH-T"><a href="#/OEBPS/c04.htm"><strong>Black and White Pillow</strong></a></h2>
<h2 class="TOC-CH-T"><a href="#/OEBPS/c05.htm"><strong>Vibrant Seating Cube</strong></a></h2>
<h2 class="TOC-CH-T"><a href="#/OEBPS/c06.htm"><strong>Fringed Ribbon Pillow</strong></a></h2>
<h2 class="TOC-CH-T"><a href="#/OEBPS/c07.htm"><strong>French Knitted Cushions</strong></a></h2>
<h2 class="TOC-CH-T"><a href="#/OEBPS/c08.htm"><strong>Blooming Rose Pillow</strong></a></h2>
<h2 class="TOC-CH-T"><a href="#/OEBPS/c09.htm"><strong>Diamond Pattern Pillow</strong></a></h2>
<h2 class="TOC-CH-T"><a href="#/OEBPS/c10.htm"><strong>Bunting Cushion</strong></a></h2>
<h2 class="TOC-FBMHD"><a href="#/OEBPS/cmtech.htm"><strong>Cushion-Making Techniques</strong></a></h2>
<h2 class="TOC-FBMHD"><a href="#/OEBPS/ftech.htm"><strong>Finishing Techniques</strong></a></h2>
<h2 class="TOC-FBMHD"><a href="#/OEBPS/ktech.htm"><strong>Knitting Techniques</strong></a></h2>
<h2 class="TOC-FBMHD"><a href="#/OEBPS/abb.htm"><strong>Abbreviations</strong></a></h2>
<h2 class="TOC-FBMHD"><a href="#/OEBPS/term.htm"><strong>US/UK Terms</strong></a></h2>
<h2 class="TOC-FBMHD"><a href="#/OEBPS/syw.htm"><strong>Standard Yarn Weights</strong></a></h2>
<h2 class="TOC-FBMHD"><a href="#/OEBPS/emsk.htm"><strong>Enjoy more Simple Knits</strong></a></h2>
<h2 class="TOC-FBMHD"><a href="#/OEBPS/cop.htm"><strong>Copyright</strong></a></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?622cab4e